import { formatMinutes as formatMinutesIn } from '@shared/calculations/pricing.ts';
import { activeLanguage } from './index.ts';

/**
 * Formatters bound to the language the app is currently showing.
 *
 * The shared implementations take a language because their other caller — the
 * Worker — composes in the *company's* language, which has nothing to do with
 * the browser. In here the answer is always the same one i18next resolved, so
 * binding it once is both less to get wrong and less to thread: nineteen call
 * sites would otherwise each have to remember an argument whose omission is
 * silent, showing "1 hr 20 min" inside an otherwise Spanish screen.
 *
 * Components re-render on a language change because they already subscribe
 * through `useTranslation`, so reading the language at call time is enough.
 */
export function formatMinutes(minutes: number): string {
  return formatMinutesIn(minutes, activeLanguage());
}
